import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as CryptoJS from "crypto-js";

// Servicios
import { UserService, SettingsService } from "../../../service/service.index";

// COMPONENT SERVICES
import { HeaderService } from "../../../components/layouts/anonymous/header/header.service";

import { Appsettings } from "../../../configuration/appsettings";

import swal from "sweetalert2";
import { StorageService } from "../../../service/shared/storage.service";

declare function addDataLayer(selement, offset): any;

declare var dataLayer;

@Component({
  selector: "app-login-valladolid",
  templateUrl: "./login-valladolid.component.html",
  styleUrls: ["./login-valladolid.component.scss"],
})
export class LoginValladolidComponent implements OnInit {
  working: boolean;
  frmLogin: FormGroup;
  urlPrivacy = Appsettings.PRIVACY_ANNOUNCEMENT;
  ccts: any[] = [];
  captchaResolved: boolean = false;
  currentYear: number;

  constructor(
    private _userSrv: UserService,
    private _storageSrv: StorageService,
    private _router: Router,
    private _srvHeader: HeaderService,
    public _srveSettings: SettingsService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe((params) => {
      if (params.email) {
        this.working = true;
        this._userSrv.userActiveCount(params.email).subscribe((res) => {
          this.working = false;
          if (res.success) {
            swal(
              Appsettings.APP_NAME,
              "Cuenta activada correctamente",
              "success"
            );
          } else {
            swal(
              Appsettings.APP_NAME,
              "Error al activar la cuenta, contacte al administrador.",
              "warning"
            );
          }
        });
      }
    });

    this.frmLogin = new FormGroup({
      username: new FormControl("", [
        Validators.required,
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$"),
      ]),
      password: new FormControl("", [Validators.required]),
      // 'recaptchaReactive': new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    this._srvHeader.showReturnButton(true);
    window.scroll(0, 0);
    this.currentYear = new Date().getFullYear();
  }

  onSubmit() {
    this.working = true;
    const userName = this.frmLogin.controls["username"].value;
    const password = this.frmLogin.controls["password"].value;
    this._userSrv.login(userName, password,4).subscribe(
      (result) => {
        console.info("Login 1");
        // console.log(result);

        if (result.access_token) {
          this._storageSrv.token = result.access_token;
          this._storageSrv.email = result.email;
          this._storageSrv.name = result.fullName;
          this._storageSrv.userName = this.frmLogin.value.username;
          this._storageSrv.rol = result.rol;
          this._storageSrv.refreshToken = result.refresh_token;
          this._storageSrv.nodeRoot= result.subsystemId;
          // switch (result.rol) {
          //   case 'Profesor que imparte cursos':

          //     break;
          //   case 'Alumno':

          //     break;
          //   case 'Profesor Bachillerato':

          //     break;
          // }
          /*
        if ( result.rol.indexOf('Administrador') > -1 ) {
          swal( Appsettings.APP_NAME, 'El rol del usuario no está permitido iniciar sesión en este sitio', 'error');
          this._router.navigateByUrl('/login');
        }
        */

          this._userSrv.getProfile().subscribe((r) => {
            console.info(r);

            if (r.success) {
              if (r.data.permissions) {
                this._storageSrv.permissions = JSON.stringify(
                  r.data.permissions
                );
              }

              if (r.data.publishingNodes) {
                this._storageSrv.nodes = JSON.stringify(r.data.publishingNodes);
                for (let o of r.data.publishingNodes) {
                  if (o.parentId == Number(this._storageSrv.nodeRoot)) {
                    console.log(o);
                  }
                }
                //r.data.publishingNodes.forEach((x) =>console.log(x));
              }

              if (r.data.notifications) {
                this._storageSrv.notifications = JSON.stringify(
                  r.data.notifications
                );
              }

              this._storageSrv.showCoupon = r.data.user.coupon;
              this._storageSrv.showAmount = r.data.user.amount;
              this._storageSrv.profileImage = r.data.user.urlImage;
              // this._srveSettings.aplicarTema(
              //   JSON.parse(this._storageSrv.nodes)
              // );

              console.log(JSON.parse(r.data.systemId));
              this._storageSrv.systemId = r.data.systemId;
              this._srveSettings.aplicarTemaSystem(JSON.parse(r.data.systemId));
              this._storageSrv.showModal = 0;
              this._storageSrv.showTour = 0;
              this._storageSrv.showTourMaterial = 0;
              this._storageSrv.showTourBooks = 0;
              this._storageSrv.showTourGexan = 0;
              this._storageSrv.showTourGexanNuevo = 0;
              this._storageSrv.showTourQbank = 0;
              this._storageSrv.showTourQbankAdd = 0;
              this._storageSrv.showTourListExam = 0;
              this._storageSrv.showTourAnoummce = 0;
              this._storageSrv.showTourGenAnoummce = 0;
              this._storageSrv.showTourCourse = 0;
              this._storageSrv.showTourRepo = 0;
              this._storageSrv.showTourForum = 0;
              this._storageSrv.showTourAddSala = 0;
              this._router.navigateByUrl("/resource/home");

              this.getDataUserLogin();

              /*
            if (result.rol.indexOf('Alumno') > -1 || result.rol.indexOf('Profesor') > -1 ) {
              this._router.navigateByUrl('/resource/home');
            } else {
              this._router.navigateByUrl('/login');
            }
            */
            } else {
              dataLayer.push(function () {
                this.reset();
              });
              dataLayer.push({
                event: "ev_log_in",
                category: "log_in",
                action: "error",
                user_id: "N/A",
                cct: "N/A",
                correo: "N/A",
                nombre_escuela: "N/A",
                clasificacion_escuela: "N/A",
                nivel: "N/A",
                entidad: "N/A",
                zona: "N/A",
                control: "N/A",
                promotor: "N/A",
                tipo_usuario: "N/A",
              });
            }

            this.getDataUser();
          });
        } else {
          swal(
            Appsettings.APP_NAME,
            "Usuario y/o contraseña no válidos",
            "error"
          );
          this.working = false;
          dataLayer.push(function () {
            this.reset();
          });
          dataLayer.push({
            event: "ev_log_in",
            category: "log_in",
            action: "error",
            user_id: "N/A",
            cct: "N/A",
            correo: "N/A",
            nombre_escuela: "N/A",
            clasificacion_escuela: "N/A",
            nivel: "N/A",
            entidad: "N/A",
            zona: "N/A",
            control: "N/A",
            promotor: "N/A",
            tipo_usuario: "N/A",
          });
        }
      },
      (err) => {
        const messageError = JSON.parse(err._body);

        if (messageError.error) {
          swal(Appsettings.APP_NAME, messageError.error, "error");
        } else {
          swal(
            Appsettings.APP_NAME,
            "Problemas al autenticar el usuario",
            "error"
          );
        }
        this.working = false;
      }
    );
  }

  checkCaptcha(captchaResponse: string) {
    this.captchaResolved =
      captchaResponse && captchaResponse.length > 0 ? true : false;
  }

  getDataUser() {
    this._userSrv.getProfileData().subscribe((r) => {
      let id;

      let ccts: string[] = [];
      if (r.success) {
        let data = r.data;
        id = data.id;
        if (data.userCCTs.length > 0) {
          for (let cct of data.userCCTs) {
            ccts.push(cct.cct);
          }
        }

        // addDataLayer(id,ccts);
      }
      this.working = false;
    });
  }

  getDataUserLogin() {
    this._userSrv.getProfileData().subscribe((r) => {
      if (r.data.userCCTs.length > 0) {
        let cct = r.data.userCCTs[0];

        const SECRET_KEY = "Larousse";
        const email = CryptoJS.SHA256(r.data.email, SECRET_KEY);
        const idUser = CryptoJS.SHA256(r.data.id, SECRET_KEY);

        let dataC = {
          event: "ev_log_in",
          category: "log_in",
          action: "exito",
          user_id: idUser.toString(),
          cct: cct.cct,
          correo: email.toString(),
          nombre_escuela: r.data.institution,
          clasificacion_escuela: cct.clasificationSchool,
          nivel: cct.level,
          entidad: cct.state,
          zona: cct.zone,
          control: cct.control,
          promotor: cct.promoter,
          tipo_usuario: r.data.role.name,
        };

        // console.log('Data c');
        // console.log(dataC);

        dataLayer.push(function () {
          this.reset();
        });

        dataLayer.push(dataC);
      }
    });
  }

  resolved(captchaResponse: string, res) {
    console.log(`Resolved response token: ${captchaResponse}`);
  }
}
